import PlanetDetailPage from '@pages/emporium/planet/detail'
import type { NextPage } from 'next'

const PlanetOtherDetailPage: NextPage<Props> = () => {
  return <PlanetDetailPage />
}

type Props = {}

export default PlanetOtherDetailPage
